import React from "react";
import "../App.css";

export default function SkeletonList({ rows = 8, height = 32, style = {} }) {
  return (
    <ul style={{ listStyle: "none", padding: 0, margin: 0, ...style }}>
      {Array.from({ length: rows }).map((_, i) => (
        <li
          key={i}
          className="ffb-skeleton-item"
          style={{
            height,
            marginBottom: 10,
            borderRadius: 6,
            background: "linear-gradient(90deg, #e0e7ff 25%, #f4f8fb 50%, #e0e7ff 75%)",
            backgroundSize: "200% 100%",
            animation: "ffb-skeleton-shimmer 1.2s infinite linear",
          }}
        />
      ))}
    </ul>
  );
} 